'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _dekuLink = require('@viskan/deku-link');

var _dekuLink2 = _interopRequireDefault(_dekuLink);

var _dekuRedux = require('@viskan/deku-redux');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _dekuRedux.connectWrap)(function (_ref, props) {
	var router = _ref.router,
	    site = _ref.site;
	return {
		localeMode: site.localeMode,
		prefix: props.prefix || router.pathPrefix
	};
})(_dekuLink2.default);